module.exports = __webpack_public_path__ + "static/media/2 1 ordkjedetekst.bb4827e3.mp3";